// per-portal config singleton populated by portalConfigLoader before React mounts (see src/index.js) - consumers use ES module live bindings: `import { CAMERAS, ROUTES, ... } from './portalConfig'`
import { ROUTES_STATIC } from './constants'

export let CAMERAS = []
export let ROUTES = { ...ROUTES_STATIC }
export let TITLE = ''
export let REFRESH_MIN = 5
export let ORDER_ID = 0

let _initialized = false
export const isPortalConfigInitialized = () => _initialized

// called once by portalConfigLoader after the GraphQL fetch; `protection` is { HOME, LIVE, TIMELAPSE, ARCHIVE, MYSITE }: bool — merged into ROUTES_STATIC
export function initPortalConfig({ cameras, title, refreshMin, orderId, protection }) {
    CAMERAS = Object.freeze(cameras)
    TITLE = title
    REFRESH_MIN = refreshMin
    ORDER_ID = orderId
    ROUTES = Object.freeze(
        Object.fromEntries(
            Object.entries(ROUTES_STATIC).map(([key, staticPart]) => [
                key,
                Object.freeze({ ...staticPart, protected: !!protection?.[key] })
            ])
        )
    )

    _initialized = true
}